import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.9993 1.5L7.9428 7.7388L1 8.74555L6.02945 13.6625L4.8272 20.5L10.9993 17.2096L17.1727 20.5L15.9793 13.6625L21 8.74555L14.0956 7.7388L10.9993 1.5Z",
      stroke: "#787878",
      "stroke-width": "2",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }